/*!
 * ПМК-167
 * (c) 2019 kirsites <kirsites@gmail.com>
 * licensed under the MIT license
 */

let App = App || {};
